import React from 'react';
import { motion } from 'framer-motion';

const TermsConditionsPage = ({ onBack }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      {/* Back Button */}
      <motion.div 
        style={{ 
          padding: '20px',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <button 
          onClick={onBack}
          style={{
            background: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#6d28d9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#7c3aed';
            e.target.style.transform = 'translateY(0px)';
          }}
        >
          ← Back to Home
        </button>
      </motion.div>

      <motion.div 
        className="terms-conditions-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          padding: '120px 20px 50px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: '#ffffff'
        }}
      >
        <motion.h1 
          style={{
            fontSize: '3rem',
            marginBottom: '20px',
            color: '#7c3aed',
            textAlign: 'center'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          📑 Terms & Conditions
        </motion.h1>
        
        <motion.p 
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
            color: '#7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Effective Date: 20/12/2024
        </motion.p>
        
        <motion.div 
          style={{
            fontSize: '1.1rem',
            marginBottom: '30px'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <p style={{ marginBottom: '30px' }}>
            These Terms & Conditions ("Terms") govern the use of LeadVala's services. By using our website, forms, or lead subscription plans, you agree to these Terms.
          </p>
        </motion.div>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            1. Services
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>LeadVala provides <strong>AI + Human Verified Lead Generation Services</strong>.</li>
            <li>Leads are delivered via WhatsApp and Google Sheets.</li>
            <li>Packages include OTP Verified, WhatsApp Leads, and Premium Call Verified Leads.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            2. Subscription & Payments
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Services are subscription-based.</li>
            <li>Fees must be paid <strong>in advance</strong>.</li>
            <li>Failure to pay may suspend or terminate access.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            3. Client Responsibilities
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Use leads only for lawful business purposes.</li>
            <li>No resale, spam, or misuse of data.</li>
            <li>Comply with Google Ads, Meta, LinkedIn, WhatsApp, and other platform rules.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            4. Lead Quality & Limitation of Liability
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Leads are <strong>verified for accuracy</strong> at the time of delivery.</li>
            <li>LeadVala does not guarantee conversions, sales, or revenue.</li>
            <li>We are not liable for indirect losses or platform failures.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            5. Refunds & Cancellations
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Covered under our <strong>Refund & Cancellation Policy</strong>.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            6. Termination
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>We may suspend or terminate accounts for policy violations.</li>
            <li>Clients may cancel with 30 days' notice.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.1 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            7. Governing Law
          </h2>
          <p style={{ lineHeight: '2' }}>
            This agreement is governed by Indian law, with jurisdiction in Ahmedabad, Gujarat.
          </p>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default TermsConditionsPage;